import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_faq_box = _resolveComponent("faq-box")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2",
      class: "_mb-6"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.PledgeManagerQuestionAndAnswersHeader), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_box, { huge: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (question) => {
            return (_openBlock(), _createBlock(_component_faq_box, {
              key: question.title,
              title: question.title,
              description: question.description,
              "is-initially-collapsed": "",
              "is-rich-text": false
            }, null, 8 /* PROPS */, ["title", "description"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}